<template>
  <div>
    <CustomCollaspe
      class="filter-collapse status"
      :collapse-id="'status-collapse'"
      :collapse-header="'Offer'"
    >
      <FilterOptionBtn>Public offer</FilterOptionBtn>
      <FilterOptionBtn>Exclusive offer</FilterOptionBtn>
    </CustomCollaspe>
  </div>
</template>

<script>
import CustomCollaspe from '@/components/BaseComponents/CustomCollapse.vue';
import FilterOptionBtn from '@/components/BaseComponents/FilterOptionBtn.vue';

export default {
  components: {
    CustomCollaspe,
    FilterOptionBtn
  }
};
</script>
